import React, { Component } from 'react'
import { Link } from 'gatsby'
import Layout from 'components/Layout'
import SEO from 'components/SEO'

// import { Container } from './styles';
import Card from 'components/Card'
import Title from 'components/Title'

import photo from 'assets/images/profile.jpg'

export default class blog extends Component {
  render() {
    return (
      <Layout>
        <SEO
          title="Blog"
          description="Projects developed for study"
          keywords="React, React JS, React Native, Node, Front-end, Back-end, API, developer"
        />
        <section className="section content is-size-4-desktop is-size-5-touch">
          <Title>Blog</Title>
          <p className="has-text-centered">
            Follow me on <a href="https://github.com/leandrodsi">GitHub</a>.
          </p>
          <div className="columns is-centered">
            <div className="column is-half">
              <Card
                title="Post #1"
                subtitle="Build your personal page using Gatsby"
                link="https://www.google.com"
                tags={['React', 'Gatsby']}
                image={photo}
              />
              <Card
                title="Post #2"
                subtitle="Build your personal page using Gatsby"
                link="https://medium.com/@luanorlandi/learn-react-easily-with-this-rule"
                tags={['React', 'Gatsby']}
                image={photo}
              />
              <Card
                title="Project #1"
                subtitle="Build your personal page using Gatsby"
                link="https://www.google.com"
                tags={['React', 'Gatsby']}
                image={photo}
              />
            </div>
          </div>
          <p className="has-text-centered">
            Check out my <Link to="/stacks">stacks</Link>.
          </p>
        </section>
      </Layout>
    )
  }
}
